// extracted by mini-css-extract-plugin
module.exports = {"alternativeGroup":"style_alternativeGroup__3mCC1IU-3TZp3aIv7wb5XK"};